import React, { useEffect, useState } from "react";
import GenoIndexStyle from "./geneindex.module.css";
import GenomeList from "../../../assets/json/Genomes/pathwoay_genomename";
import geneidlist from "../../../assets/json/Geneindexv2/geneid";
import generegionlist from "../../../assets/json/Geneindexv2/generegion";
import geneindexlist from "../../../assets/json/Geneindexv2/geneindex";
import { Button, Flex, Form, Input, Modal, Select, Table, Upload } from "antd";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/下载.svg";
import { UploadOutlined } from "@ant-design/icons";
import http from "../../../utils/http";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
const { TextArea } = Input;

function GeneIndex() {
  const location = useLocation();
  const [form] = Form.useForm();
  const [MethodVal, setMethodVal] = useState("gene_id"); // 默认值设置为 'gene_id'
  const [fileContent, setFileContent] = useState("");
  const [TableData, setTableData] = useState([]);
 const [IsSubmitLoading, setIsSubmitLoading] = useState(false);
  const onFinish = (values) => {
    console.log("Success:", values);
    setIsSubmitLoading(true)
    if (MethodVal === "gene_id") {
      console.log("gene_id查询");
      http
        .get(
          `/api/genome/geneIndex/?species=${values.genomes}&gene_id=${values.gene_id}`
        )
        .then((res) => {
          console.log(res);
          setTableData(res);
    setIsSubmitLoading(false)
        })
        .catch((err) => {
          console.log(err);
    setIsSubmitLoading(false)

        });
    } else if (MethodVal == "gene_region") {
      console.log("gene_region查询");
      http
        .get(
          `/api/genome/geneIndex/?species=${values.genomes}&gene_region=${values.gene_region}`
        )
        .then((res) => {
          console.log(res);
          setTableData(res);
    setIsSubmitLoading(false)

        })
        .catch((err) => {
          console.log(err);
    setIsSubmitLoading(false)

        });
    } else if (MethodVal == "gene_index") {
      console.log("gene_index查询");
      console.log(values.SN == undefined ? values.textFile : values.SN.file);
      const newFormData = new FormData();
      const gene_idObject = {
        species: values.genomes,
        gene_index: values.SN == undefined ? values.textFile : values.SN.file,
      };
      Object.keys(gene_idObject).forEach((key) => {
        newFormData.append(key, gene_idObject[key]);
      });
      http
        .post("/api/genome/geneIndex/", newFormData)
        .then((res) => {
          console.log(res);
          setTableData(res);
    setIsSubmitLoading(false)

        })
        .catch((err) => {
          console.log(err);
    setIsSubmitLoading(false)

        });
    }
  };

  const contentUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const content = event.target.result;
      setFileContent(content);
    };
    reader.readAsText(file);
    return false; // 阻止默认上传行为
  };
  useEffect(() => {
    form.setFieldsValue({
      textFile: fileContent,
    }); // 初始化时更新文本域的值
  }, [fileContent]);
  const [GenomeVal, setGenomeVal] = useState("");
  const GeneIDExample = (item) => {
    form.setFieldsValue({
      gene_id: item,
    });
  };
  const GeneidHelpFn = () => {
    const filtered = geneidlist.filter((item) =>
      GenomeVal.includes(item.species)
    );
    return (
      <p style={{ cursor: "pointer" }}>
        {filtered[0]?.gene_id.map((v) => {
          return (
            <span
              style={{ margin: "0 5px" }}
              onClick={() => {
                GeneIDExample(v);
              }}
            >
              {v}
            </span>
          );
        })}
      </p>
    );
  };
  const getGeneRegionExample = () => {
    const content = document.querySelector(".GeneRegionExample").textContent;
    console.log(content);
    form.setFieldsValue({
      gene_region: content,
    });
  };
  const GeneRegionHelpFn = () => {
    const filtered = generegionlist.filter((item) =>
      GenomeVal.includes(item.species)
    );
    return (
      <p
        onClick={getGeneRegionExample}
        style={{ cursor: "pointer" }}
        className="GeneRegionExample"
      >
        {filtered[0]?.gene_region}
      </p>
    );
  };
  const GeneIndexExample = () => {
    const content = document.querySelector(".GeneIndexExample").textContent;
    setFileContent(content);
    form.setFieldsValue({ textFile: content });
  };
  const GeneIndexHelpFn = () => {
    const filtered = geneindexlist.filter((item) =>
      GenomeVal.includes(item.species)
    );
    return (
      <p
        style={{ cursor: "pointer" }}
        className="GeneIndexExample"
        onClick={GeneIndexExample}
      >
        {filtered[0]?.gene_index}
      </p>
    );
  };
  const onChangeInput_Upload = () => {
    if (MethodVal === "gene_id") {
      return (
        <Form.Item name="gene_id" help={<span>{GeneidHelpFn()}</span>}>
          <Input placeholder="Gene ID" />
        </Form.Item>
      );
    } else if (MethodVal === "gene_region") {
      return (
        <Form.Item name="gene_region" help={<span>{GeneRegionHelpFn()}</span>}>
          <Input placeholder="Gene Region" />
        </Form.Item>
      );
    } else if (MethodVal === "gene_index") {
      return (
        <Flex vertical>
          <Form.Item
            name="textFile"
            rules={[
              {
                required: true,
                message: "This field cannot be empty.",
              },
            ]}
            help={GeneIndexHelpFn()}
          >
            <TextArea
              style={{ width: 300 }}
              value={fileContent}
              onChange={(e) => setFileContent(e.target.value)}
              placeholder="Click to select file or drag file containing query
                      sequence(s) in FASTA format here..."
            />
          </Form.Item>
          <Form.Item
            name="SN"
            style={{
              width: "60%",
            }}
          >
            <Upload
              beforeUpload={contentUpload}
              name="SN"
              action="/upload.do"
              onRemove={() => {
                setFileContent("");
              }}
              listType="text"
            >
              <Button
                style={{
                  border: "none",
                  padding: "0",
                  margin: "0",
                  background: "transparent",
                }}
                icon={<UploadOutlined />}
              >
                Click to upload
              </Button>
            </Upload>
          </Form.Item>
        </Flex>
      );
    }
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [BiologicalVal, setBiologicalVal] = useState("");
  const [CellularVal, setCellularVal] = useState("");
  const [MolecularVal, setMolecularVal] = useState("");
  const [GoContnetOne, setGoContentOne] = useState("");
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const [IsSpShow, setIsSpShow] = useState(false);
  const [SpContent,setSpContent]=useState("")
  const [IsHeight,setISHeight]=useState("")
  const showModalSp = () => {
    setIsSpShow(true);
  };
  const handleOkSp = () => {
    setIsSpShow(false);
  };
  const handleCancelSp = () => {
    setIsSpShow(false);
  };
  const [IsKEGGShow, setIsKEGGShow] = useState(false);
  const [KEGGContent_index,setKEGGContent_index]=useState("")
  const [KEGGContent_name,setKEGGContent_name]=useState("")
  const [KEGGContent_link,setKEGGContent_link]=useState("")
  const [KEGGContent_pathway,setKEGGContent_pathway]=useState("")
  const showModalKEGG = () => {
    setIsKEGGShow(true);
  };
  const handleOkKEGG = () => {
    setIsKEGGShow(false);
  };
  const handleCancelKEGG = () => {
    setIsKEGGShow(false);
  };
  const colums = [
    {
      key: "1",
      title: "Chr",
      dataIndex: "gene_name",
      align: "center",
    },
    {
      key: "2",
      title: "Gene ID",
      dataIndex: "gene_id",
      align: "center",
    },
    {
      key: "3",
      title: "mRNA ID",
      dataIndex: "mrna_id",
      align: "center",
    },
    {
      title: <p style={{ fontWeight: "bold" }}>Position</p>,
      dataIndex: "position",
      key: "position",
      // width: "20%",
      align: "center",
      render: (index, item) => {
        return (
          <p>
            <span>{item.chr}:</span>
            <span>{item.start}-</span>
            <span>{item.end}</span>
          </p>
        );
      },
    },
    {
      // width: "35%",
      title: <p style={{ fontWeight: "bold" }}>KEGG</p>,
      dataIndex: "gene_KO_ID",
      key: "gene_KO_ID",
      align: "center",
      render: (index, item) => {
        return (
          <p
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: "50px",
              overflow: "auto",
              cursor: "pointer"
            }}
            onClick={()=>{
              showModalKEGG()
              setKEGGContent_index(index)
              setKEGGContent_name(item.gene_KO_name)
              setKEGGContent_link(item.gene_KO_link)
              setKEGGContent_pathway(item.gene_Pathway)
            }}
          >
            <span>{index}</span>
            <span>{item.gene_KO_name}</span>
            <span>{item.gene_KO_link}</span>
            <span>{item.gene_Pathway}</span>
          </p>
        );
      },
    },
  
        {
          title: <p style={{ fontWeight: "bold" }}>Swissprot</p>,
          dataIndex: "sp",
          key: "sp",
          width: "300px",
          align: "center",
          render: (index, item) => {
            return <p style={{
              height:"50px",
              overflow:"auto",
              cursor:"pointer"
            }}
            onClick={()=>{
              showModalSp(true)
              setSpContent(index)
              setISHeight("sp")

            }}
            >{index}</p>;
          },
        },
        {
          title: <p style={{ fontWeight: "bold" }}>GO</p>,
          dataIndex: "go",
          key: "go",
          width: "300px",
          align: "center",
          render: (index, items) => {
            return (
              <p
                className={GenoIndexStyle.go_content}
                onClick={() => {
                  setBiologicalVal(items.gene_Biological_Process);
                  setCellularVal(items.gene_Cellular_Component);
                  setMolecularVal(items.gene_Molecular_Function);
                  // setGoContentOne(items.gene_go);
                  showModal();
                }}
              >
                {/* <span>{items.gene_go}</span> */}
                <span>{items.gene_Biological_Process}</span>
                <span>{items.gene_Cellular_Component}</span>
                <span>{items.gene_Molecular_Function}</span>
              </p>
            );
          },
        },
    {
      key:"transcripts",
      dataIndex:"transcripts",
      align:"center",
      title:"mRNA Sequences",
      render: (index, item) => {
        return <p style={{
          width:"200px",
              height:"80px",
              overflow:"auto",
              cursor:"pointer"
            }}
            onClick={()=>{
              showModalSp(true)
              setSpContent(index)
              setISHeight("mRNA")
            }}
        >{index}</p>;
      },
    }, {
      key:"gene",
      dataIndex:"gene",
      align:"center",
      title:"DNA Sequences",
      render: (index, item) => {
        return <p style={{
          width:"200px",
              height:"80px",
              overflow:"auto",
              cursor:"pointer"
            }}
            onClick={()=>{
              showModalSp(true)
              setSpContent(index)
              setISHeight("dna")
            }}
        >{index}</p>;
      },
    },{
      key:"cds",
      dataIndex:"cds",
      align:"center",
      title:"CDS",
      render: (index, item) => {
        return <p style={{
          width:"200px",
              height:"80px",
              overflow:"auto",
              cursor:"pointer"
            }}
            onClick={()=>{
              showModalSp(true)
              setSpContent(index)
              setISHeight("CDS")
            }}
        >{index}</p>;
      },
    },{
      key:"pep",
      dataIndex:"pep",
      align:"center",
      title:"PEP",
      render: (index, item) => {
        return <p style={{
          width:"200px",
              height:"80px",
              overflow:"auto",
              cursor:"pointer"
            }}
            onClick={()=>{
              showModalSp(true)
              setSpContent(index)
              setISHeight("pep")
            }}
        >{index}</p>;
      },
    }
  ];
   // 文件下载函数
   function downloadCSV(csvString, filename) {
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = filename || "data.csv"; // 设置文件名
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
  const handleDownloadCSV = () => {
    if (TableData.length === 0) {
      alert("No data to download");
      return;
    }

    // 从表单中获取 Genome 的值
    const genomeValue = form.getFieldValue("genomes");

    // 如果 Genome 值为空，使用默认文件名
    const filename = genomeValue ? `${genomeValue}.csv` : "table_data.csv";

    // 将表格数据转换为 CSV 字符串
    const csvString = convertToCSV(TableData);

    // 触发文件下载
    downloadCSV(csvString, filename);
  };
  function convertToCSV(jsonData) {
    if (!jsonData || jsonData.length === 0) {
      return "";
    }

    const columns = Object.keys(jsonData[0]);
    let csvString = columns.join(",") + "\n";

    jsonData.forEach((row) => {
      let rowString = columns
        .map((column) => {
          let value = row[column];
          if (
            typeof value === "string" &&
            (value.includes(",") || value.includes("\n") || value.includes('"'))
          ) {
            value = `"${value.replace(/"/g, '""')}"`; // 替换双引号为两个双引号
          }
          return value;
        })
        .join(",");
      csvString += rowString + "\n";
    });

    return csvString;
  }
  return (
    <div className={GenoIndexStyle.GeneIndex_app}>
      <div className={GenoIndexStyle.GeneIndex_Header}>
        <p>Gene Index</p>
      </div>
         <Modal open={IsKEGGShow} onOk={handleOkKEGG} onCancel={handleCancelKEGG} style={{textAlign:"center"}}>
              
              <p>
                {KEGGContent_index}
              </p>
              <p>
                {KEGGContent_name}
              </p>
              <p>
                {KEGGContent_link}
                </p>
                <p>
                {KEGGContent_pathway}
                </p>
            </Modal>
            <Modal open={IsSpShow} onOk={handleOkSp} onCancel={handleCancelSp}>
      <p style={{padding:"10px",overflow:"auto",height:IsHeight=='sp'?"auto":"500px",margin:"20px"}}>{SpContent}</p>
            </Modal>
      <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        <div 
         style={{padding:"10px",overflow:"auto",height:"500px",margin:"20px"}}
        >
          <p>{GoContnetOne}</p>
        <p>
          <span style={{ fontWeight: "bold" }}>Biologoica process:</span>
          {BiologicalVal}
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Cellular component:</span>
          {CellularVal}
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Molecular function:</span>
          {MolecularVal}
        </p>
        </div>
        
      </Modal>
      <div className={GenoIndexStyle.GeneIndex_Form_div}>
        <Form
          form={form}
          onFinish={onFinish}
          layout="inline"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Form.Item
            label={<span style={{ fontWeight: "bold" }}>Genome</span>}
            name="genomes"
          >
            <Select
              options={GenomeList}
              style={{ width: 200 }}
              onChange={(e) => {
                setGenomeVal(e);
              }}
            />
          </Form.Item>
          <Form.Item label={<span style={{ fontWeight: "bold" }}>Method</span>}>
            <Select
              style={{ width: 200 }}
              defaultValue="gene_id" // 设置默认选中项
              onChange={(e) => {
                setMethodVal(e);
              }}
              options={[
                {
                  key: "1",
                  label: "Gene ID",
                  value: "gene_id",
                },
                {
                  key: "2",
                  label: "Gene Region",
                  value: "gene_region",
                },
                {
                  key: "3",
                  label: "Gene Index",
                  value: "gene_index",
                },
              ]}
            />
          </Form.Item>
          {onChangeInput_Upload()}
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                margin: "0 10px",
                background: "#67C23A",
                border: "none",
                color: "white",
              }}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className={GenoIndexStyle.GeneDetail_div}>
        <div
        style={{
          width:"95%",
          margin:"10px auto",
          display:"flex",
          justifyContent:"flex-end"
          
        }}
        >
          <Button
          onClick={handleDownloadCSV}
          >
            <DownloadIcon width={20}/>
            CSV
          </Button>
        </div>
        <Table
          style={{ width: "95%", margin: "auto" }}
          columns={colums}
          dataSource={TableData}
          bordered
          scroll={{
            x:1500
          }}
        />
      </div>
    </div>
  );
}

export default GeneIndex;
